import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  loginOnboard, signupOnboard, loginOnboardRecurring,
  resetEmailOnBoard, saveAddtionalInfoOnBoard, continueWithSocial
} from 'redux/actions/onBoard';
import { Auth } from 'components/Auth';
import './DefaultAuth.scss';

function DefaultAuth(props) {
  return (
    <div className="Onboard__DefaultAuth">
      <Auth
        logo="/images/logo/Muse_Account_Logo.png"
        auth={props.onBoard}
        loginAuth={props.loginOnboard}
        signupAuth={props.signupOnboard}
        continueWithSocial={props.continueWithSocial}
        resetEmailAuth={props.resetEmailOnBoard}
        loginAuthRecurring={props.loginOnboardRecurring}
        saveAddtionalInfoAuth={props.saveAddtionalInfoOnBoard}
        resetEmailClassName="Onboard__DefaultAuth__ResetModal"
        verifyEmailClassName="Onboard__DefaultAuth__VerifyModal"
      />
    </div>
  );
}

DefaultAuth.propTypes = {
  onBoard: PropTypes.object.isRequired,
  loginOnboard: PropTypes.func.isRequired,
  signupOnboard: PropTypes.func.isRequired,
  continueWithSocial: PropTypes.func.isRequired,
  resetEmailOnBoard: PropTypes.func.isRequired,
  loginOnboardRecurring: PropTypes.func.isRequired,
  saveAddtionalInfoOnBoard: PropTypes.func.isRequired
};

function mapStateToProps({ onBoard }) {
  return { onBoard };
}

export default connect(
  mapStateToProps,
  {
    loginOnboard,
    signupOnboard,
    resetEmailOnBoard,
    continueWithSocial,
    loginOnboardRecurring,
    saveAddtionalInfoOnBoard
  }
)(DefaultAuth);



// WEBPACK FOOTER //
// ./src/views/OnBoard/DefaultAuth/DefaultAuth.jsx